<div class="component-content col-lg-6" style="height:90%;">
    <div class="panel panel-success" style="height:90%;">
        <div class="panel-heading">
            <h5 style="display: inline-block">
                <span class="badge">{{ selectedDocuments.Data.length }}</span>
                <span>Selected Documents</span>
            </h5>
            <div class="btn-toolbar pull-right">
                <div class="btn-group btn-group-md">
                    <button type="button" class="btn btn-primary" title="Restrict Print" (click)="promptNoPrintConfirm()">
                        <span data-toggle="tooltip" class="fa fa-ban fa-lg"></span>
                    </button>
                    <button type="button" class="btn btn-primary" title="Allow Print" (click)="promptPrintConfirm()">
                        <span data-toggle="tooltip" class="fa fa-print fa-lg"></span>
                    </button>
                    <button type="button" class="btn btn-primary" title="Clear Selected" (click)="clearSelectedDocuments()">
                        <span data-toggle="tooltip" class="fa fa-trash-o fa-lg"></span>
                    </button>
                </div>
            </div>
        </div>
        <div class="panel-body panel-list" style="height:90%; overflow-y:hidden; padding-bottom:0px; padding-top:0px;">
            <div class="panel-group" style="height:100%; overflow-y:hidden;">
                <div class="list-group" style="height: 90%; overflow-y: auto; max-height: 930px">
                    <div class="list-group-item" style="padding-top:0px; padding-bottom:0px;" *ngFor="let document of selectedDocuments.Data">
                        <h5 style="display: inline-block">
                            <span class="badge"> {{ document.EquipmentCount }}</span>
                            {{ document.FileName }}&nbsp;&nbsp;&nbsp;{{ document.ProductName }}
                            <br />
                            {{ document.AllowPrinting ? 'Able to Print' : 'Not Able to Print' }}
                        </h5>
                        <div class="pull-right" style="padding-right:30px;">
                            <h5>
                                {{ document.Updated | amDateFormat: 'MM/DD/YYYY'  }}
                                <br />
                                {{ document.Version }}
                            </h5>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="component-content col-lg-6" style="height:90%;">
    <div class="panel panel-success" style="height:90%;">
        <div class="panel-heading">
            <h5 style="display: inline-block">
                <span class="badge">{{ filteredDocuments.length }} / {{ total }}</span>
                <span>Available Documents</span>
            </h5>
            <div class="pull-right">
                <div class="btn-group btn-group-md">
                    <a class="btn" title="Filter Documents" [class.btn-warning]="filterApplied" [class.btn-primary]="!filterApplied" (click)="showFilters()">
                        <span data-toggle="tooltip" class="fa fa-filter fa-lg"></span>
                    </a>
                </div>
            </div>
        </div>
        <div class="panel-body panel-list" style="height:90%; overflow-y:hidden; padding-bottom:0px; padding-top:0px;">
            <div class="panel-group" style="height:100%; overflow-y:hidden;">
                <div *ngIf="processing" class="list-group" style="overflow-y:scroll; max-height: 600px;">
                    <i class="fa fa-spinner fa-spin"></i> Loading Documents...
                </div>
                <div class="list-group" style="height:90%; overflow-y: scroll;" *ngIf="!processing">
                    <div class="list-group-item" [class.list-group-item-success]="document.Selected" style="padding-top:0px; padding-bottom:0px;" *ngFor="let document of filteredDocuments; let i = index" (click)="selectDocument(document, i+1, $event)">
                        <h5 style="display: inline-block">
                            <span class="badge"> {{ document.EquipmentCount }}</span>
                            {{ document.FileName }}&nbsp;{{ document.ProductName }}
                            <br />
                            {{ document.AllowPrinting ? 'Able to Print' : 'Not Able to Print' }}
                        </h5>
                        <div class="pull-right" style="padding-right:30px;">
                            <h5>
                                {{ document.Updated | amDateFormat: 'MM/DD/YYYY'  }}
                                <br />
                                {{ document.Version }}
                            </h5>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div bsModal #confirmPrint="bs-modal" class="modal fade" [config]="{ keyboard: false, backdrop: 'static' }" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel">
                    Allow Print Confirmation
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        Are you sure you want to allow all these documents to print?
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-warning" (click)="allowPrint()">Allow Print</button>
                <button type="button" class="btn btn-primary" (click)="cancelPrint()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<div bsModal #confirmNoPrint="bs-modal" class="modal fade" [config]="{ keyboard: false, backdrop: 'static' }" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel">
                    Restrict Print Confirmation
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        Are you sure you want to restrict the printing of these documents?
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-warning" (click)="restrictPrint()">Restrict Print</button>
                <button type="button" class="btn btn-primary" (click)="cancelNoPrint()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<div bsModal #documentFilter="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog" style="width:1000px;">
        <div class="modal-content">
            <form (ngSubmit)="applyFilter()">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="applyFilter()">&times;</button>
                    <h4 class="modal-title" id="myModalLabel">Filter Documents</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>System Code</label>
                                </div>
                                <input name="fileNameFilter" type="text" class="form-control" placeholder="System Code" [(ngModel)]="fileName" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">
                            <div class="checkbox">
                                <label><input id="AbleToPrint" name="AbleToPrint" type="checkbox" [(ngModel)]="ableToPrint">Able to Print</label>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="checkbox">
                                <label><input id="NotAbleToPrint" name="NotAbleToPrint" type="checkbox" [(ngModel)]="notAbleToPrint">Not Able to Print</label>
                            </div>
                        </div>
                        <div class="col-md-8">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row" *ngIf="attributes.length > 0">
                        <div class="col-lg-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>{{ attributes[0].Name }}</label>
                                </div>
                                <select name="selectedModels" class="form-control" size="8" multiple="multiple" [(ngModel)]="selectedModels">
                                    <option *ngFor="let map of attributes[0].Maps.Data" [value]="map">{{ map.Part }} > {{ map.Value }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>{{ attributes[1].Name }}</label>
                                </div>
                                <select name="selectedModels" class="form-control" size="8" multiple="multiple" [(ngModel)]="selectedPoweredBys">
                                    <option *ngFor="let map of attributes[1].Maps.Data" [value]="map">{{ map.Part }} > {{ map.Value }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row" *ngIf="attributes.length > 0">
                        <div class="col-lg-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>{{ attributes[2].Name }}</label>
                                </div>
                                <select name="selectedModels" class="form-control" size="8" multiple="multiple" [(ngModel)]="selectedSuites">
                                    <option *ngFor="let map of attributes[2].Maps.Data" [value]="map">{{ map.Part }} > {{ map.Value }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>{{ attributes[4].Name }}</label>
                                </div>
                                <select name="selectedModels" class="form-control" size="8" multiple="multiple" [(ngModel)]="selectedLanguages">
                                    <option *ngFor="let map of attributes[4].Maps.Data" [value]="map">{{ map.Part }} > {{ map.Value }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" *ngIf="filterApplied" (click)="clearFilter()">Clear Filter</button>
                    <button type="submit" class="btn btn-default">Apply Filter</button>
                </div>
            </form>
        </div>
    </div>
</div>